/**
 * شهری که هنوز هیچ محتوایی ندارد (WHOSUP-283) — قرینه‌ی
 * apps/mobile/src/features/discover/PioneerCard.tsx.
 *
 * به‌جای «هیچی نیست»، کاربر پیشگامِ شهرش است: جمع‌آوری شروع شده، دو کار
 * جلویش هست (دعوتِ دوستان، ساختنِ برنامه)، و اگر شهرِ نزدیکی محتوا دارد
 * یک دکمه به آن. چرا «به‌زودی» و نه «از فردا» — نگاه کن به core/lib/pioneerCity.
 */
import { useNavigate } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { cityRepo } from '@/core/data/cityRepo';
import { setTempCity, useCityScope } from '@/core/lib/cityScope';
import { t } from '@/core/lib/i18n';
import { nearbyCity } from '@/core/lib/pioneerCity';
import { Btn, Card } from '@/ui/kit';

export function PioneerCard() {
  const city = useCityScope();
  const navigate = useNavigate();
  // همان کلیدِ CityMenu: یک فهرست، یک بار.
  const cities = useQuery({ queryKey: ['appCities'], queryFn: cityRepo.list });
  const near = nearbyCity(city, cities.data ?? []);
  const name = city?.name ?? '';

  return (
    <Card className="pioneer">
      <h2>{t('pioneerTitle', { city: name })}</h2>
      <p className="dim">{t('pioneerBody', { city: name })}</p>
      <div className="pioneer-actions">
        <Btn label={t('pioneerInvite')} onClick={() => navigate('/friends')} />
        <Btn label={t('pioneerCreate')} kind="outline" onClick={() => navigate('/signal/new')} />
      </div>
      {near ? (
        <Btn label={t('pioneerNearby', { city: near.name })} kind="outline"
          onClick={() => setTempCity(near)} />
      ) : null}
    </Card>
  );
}
